<div *ngIf="root">
  <div class="app-table-search-field">
    <p-inputgroup [style]="{ 'width': '300px' }">
      <input
        #searchInput
        [style.height]="'40px'"
        pInputText
        [placeholder]="placeholder"
        [ngModel]="searchTerm"
        (ngModelChange)="filterChange.emit($event)"
        (focus)="focusEvent()"
        fluid
      />
      <p-inputgroup-addon *ngIf="searchTerm">
        <p-button
          severity="contrast"
          variant="text"
          (click)="clearSearchTerm()"
          type="button"
        >
          <i class="fa-thin fa-xmark"></i>
        </p-button>
      </p-inputgroup-addon>
    </p-inputgroup>
  </div>
</div>
<div [ngClass]="{ 'file-explorer-root-wrapper': root }">
  <div [ngClass]="{ 'file-explorer-root': root }">
    <ul
      style="position: relative"
      [ngClass]="{
        'file-explorer-root-list': root,
        'file-explorer-background': backgroundColor === 'background',
        'file-explorer-background-contrast': backgroundColor !== 'background'
      }"
      *ngIf="showList || shouldPersistList"
    >
      <li *ngFor="let item of items">
        <div
          *ngIf="item.type === 'folder'"
          (click)="onItemClick(item)"
          class="file-explorer-content-container"
          (mouseenter)="hoveredItem = item"
          (mouseleave)="hoveredItem = null"
        >
          <div
            class="file-explorer-content-icon-wrapper"
            [style.min-height]="'16px'"
          >
            <i *ngIf="!item?.expanded" class="fa-regular fa-folder"></i>
            <i *ngIf="item?.expanded" class="fa-regular fa-folder-open"></i>
          </div>
          <div class="file-explorer-content-name-button-wrapper">
            <span
              class="file-explorer-content-name"
              [ngClass]="{
                'file-explorer-content-name-selected':
                  selected && selected === item?.id,
                'active-item-menu': item?.id == menuState?.item?.id,
                'inactive-item-menu': item?.id != menuState?.item?.id
              }"
              >{{ item.name }}</span
            >
            <span
              class="file-explorer-menu-btn"
              (click)="handleToggleMenu($event, item)"
              *ngIf="hoveredItem === item && item.menuItems?.length"
              [style.min-width]="'14px'"
            >
              <i class="fa-solid fa-ellipsis"></i>
            </span>
          </div>
        </div>

        <ul *ngIf="item.type === 'folder' && item.children && item.expanded">
          <app-file-explorer-input
            [(menuState)]="menuState"
            (toggleMenu)="handleToggleMenu($event.event, $event.item)"
            [showList]="true"
            [backgroundColor]="backgroundColor"
            [root]="false"
            [items]="item.children"
            [selected]="selected"
            (itemClicked)="onItemClick($event)"
          ></app-file-explorer-input>
        </ul>
        <span
          [showDelay]="750"
          tooltipPosition="left"
          [tooltipEvent]="!item?.tooltip ? 'noop' : 'hover'"
          [pTooltip]="item.tooltip"
          class="file-explorer-content-container file-explorer-file"
          *ngIf="item.type !== 'folder'"
          (click)="onItemClick(item)"
          (mouseenter)="hoveredItem = item"
          (mouseleave)="hoveredItem = null"
        >
          <ng-container [ngSwitch]="item?.type">
            <div class="file-explorer-content-icon-wrapper">
              <i *ngSwitchCase="'workbook'" class="fa-regular fa-notebook"></i>
              <i
                *ngSwitchCase="'loading'"
                class="fas fa-spinner fa-spinner-small fa-spin"
              ></i>
              <i *ngSwitchDefault class="fa-regular fa-file-code"></i>
            </div>
          </ng-container>
          <div class="file-explorer-content-name-button-wrapper">
            <span
              class="file-explorer-content-name"
              [ngClass]="{
                'file-explorer-content-name-selected':
                  selected && selected === item?.id,
                'active-item-menu': item?.id == menuState?.item?.id,
                'inactive-item-menu': item?.id != menuState?.item?.id
              }"
            >
              {{ item.name }}
            </span>
            <span
              class="file-explorer-menu-btn"
              (click)="handleToggleMenu($event, item)"
              *ngIf="hoveredItem === item && item.menuItems?.length"
              [style.min-width]="'14px'"
            >
              <i class="fa-solid fa-ellipsis"></i>
            </span>
          </div>
        </span>
      </li>
    </ul>
  </div>
</div>
<!-- first level menu-->
<ng-container *ngIf="root">
  <div
    class="file-explorer-menu"
    *ngIf="menuState?.isOpen"
    [ngStyle]="{ top: menuState.top, left: menuState.left }"
  >
    <ul>
      <li
        *ngFor="let menuItem of menuState.item?.menuItems"
        (click)="handleMenuItemClicked($event, menuItem)"
        (mouseenter)="
          menuItem.menuItems ? openSubmenu($event, menuItem) : closeSubmenu()
        "
      >
        {{ menuItem.label }}
        <span *ngIf="menuItem?.menuItems?.length"
          ><i style="font-size: 11px" class="fa-regular fa-chevron-right"></i
        ></span>
      </li>
    </ul>
  </div>
</ng-container>

<!--second level menu --- not super scalable but how many more levels should we add? -->
<ng-container *ngIf="root">
  <div
    class="file-explorer-submenu"
    *ngIf="submenuState?.isOpen"
    [ngStyle]="{ top: submenuState.top, left: submenuState.left }"
  >
    <ul>
      <li
        *ngFor="let subItem of submenuState.item?.menuItems"
        (click)="handleMenuItemClicked($event, subItem)"
      >
        {{ subItem.label }}
      </li>
    </ul>
  </div>
</ng-container>
